import { useEffect } from 'react';
import { pushGaStepEvent } from 'actions/loan';
import { GTM_EVENT_NAMES } from 'consts/gtmEvents';
import { BANK_SCRAPING_STATUS } from 'consts/loan/AU';
import { trackProvisoStatus } from './trackProvisoStatus';

export const useBankScrapingStatusTracking = ({
  dispatch, isComplete, isLoginFail, bankScrapingResult,
}) => {
  const { status, error, errorCode } = bankScrapingResult;

  useEffect(() => {
    const isErrorStatus = status === BANK_SCRAPING_STATUS.ERROR;
    const isFailing = isLoginFail || isErrorStatus;

    if (isComplete) {
      dispatch(pushGaStepEvent(GTM_EVENT_NAMES.INCOME_COMPLETE));
    } else if (isFailing) {
      dispatch(trackProvisoStatus({ status, status_message: error, status_code: errorCode }));
    }
  }, [dispatch, status, error, errorCode]);
};
